import { useNavigate } from "react-router-dom";
import "./UploadsMenu.css";

export default function UploadsMenu() {
  const navigate = useNavigate();

  const menuItems = [
    { name: "App Uploads", path: "/app-uploads" },
    { name: "Web Uploads", path: "/web-uploads" },
  ];

  return (
    <div className="gallery-page">
      <div className="breadcrumb">
        <span>Uploads Menu</span>
      </div>

      <div className="gallery">
        {menuItems.map((item) => (
          <div
            key={item.path}
            className="folder-card"
            onClick={() => navigate(item.path)}
          >
            <div className="folder-icon">
              <img src="/assets/folder.png" alt="Folder" />
            </div>
            <div className="folder-name">{item.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
